    <p-toolbar class="width100p" [class.border-none]="noBorder">
        <div class="toolbar-div width100p" [class.align-items-center]="center" [class.sb]="spaceBetween">
            <ng-content>
            </ng-content>
        </div>
    </p-toolbar>
